import { getMockPolicies } from "../builders/getMockPolicies";
import { legacyUsSecondGearMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const michaelJordan: MockPersona = {
  key: "michaelJordan",
  name: "Michael Jordan",
  description: "🇺🇸 | Single Enthusiast+ policy | HDC 1.0 Single-tier | No alerts/autopay successful",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: getMockPolicies("apex456"),
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "michael@jordan.com",
            firstName: "Michael",
            middleName: "",
            lastName: "Jordan",
            mailingAddress: {
              line1: "115 N Front St",
              line2: "",
              city: "Wilmington",
              state: "NC",
              postalCode: "28401-5476",
              country: "USA",
            },
            preferredPhone: "9102746501",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000023",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyUsSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
